// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1uINA","title":"ClientInsurance_title__3Gsks","itemText":"ClientInsurance_itemText__37rYw"};